import { axios } from '@rossum/api-client';

type MetabaseErrorData = {
  via?: Array<{ message?: string }>;
  message?: string;
};

const getErrorData = (error: unknown): MetabaseErrorData | undefined => {
  if (axios.isAxiosError(error)) {
    return error.response?.data as MetabaseErrorData | undefined;
  }
  return undefined;
};

export const extractMetabaseAuthErrorMessage = (error: unknown): string => {
  const data = getErrorData(error);

  const viaMessage = data?.via?.[0]?.message;
  if (viaMessage) {
    return viaMessage;
  }

  if (data?.message) {
    return data.message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return 'Failed to authenticate with Metabase. Please try again later.';
};
